import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HTTPResponseModalComponent } from '../components/http-response-modal/http-response-modal.component';
import { TranslateService } from '@ngx-translate/core';

interface ServerAPIMessage {
  _children?: {
    [language: string]: {
      _value: string;
    };
  };
  _nodeFactory?: any;
}

@Injectable({
  providedIn: 'root'
})
export class HttpResponsesService {

  private isErrorShowing = false;
  private isSuccessShowing = false;
  private isInfoShowing = false;

  constructor(private modalController: ModalController,
    private translateService: TranslateService
  ) { }

  async showWebError(error): Promise<void> {

    // Prevent multiple modals
    if (this.isSuccessShowing) {
      return;
    }
    this.isSuccessShowing = true;

    const modal = await this.modalController.create({
      component: HTTPResponseModalComponent,
      componentProps: {
        status: 400,
        message: error
      },
      cssClass: 'http-response-modal'
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    this.isSuccessShowing = false;
  }

  async showServerSuccess(id: string | number, message: any): Promise<void> {
    let language = localStorage.getItem('lang');

    if (!language) {
      language = 'en';
    }

    if (language === 'ca') {
      language = 'cat';
    }
    let displayMessage = '';
    let messageObj;

    try {

      // Convert message to object if it's a string
      if (typeof message === 'string') {
        try {
          messageObj = JSON.parse(message);
        } catch (e) {
          messageObj = { en: message }; // Fallback if parsing fails
        }
      } else {
        messageObj = message;
      }

      // Simple language selection logic
      if (messageObj[language]) {
        displayMessage = messageObj[language];
      } else if (messageObj.en) {
        displayMessage = messageObj.en;
      } else if (Object.keys(messageObj).length > 0) {
        displayMessage = messageObj[Object.keys(messageObj)[0]];
      } else {
        displayMessage = String(message);
      }
    } catch (error) {
      displayMessage = String(message);
    }

    if (id === 0) {
      displayMessage = this.translateService.instant('COMMON.ALERT.SERVER_ERROR');
    }

    // Prevent multiple modals
    if (this.isSuccessShowing) {
      return;
    }
    this.isSuccessShowing = true;

    const modal = await this.modalController.create({
      component: HTTPResponseModalComponent,
      componentProps: {
        status: id,
        message: displayMessage
      },
      cssClass: 'http-response-modal'
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    this.isSuccessShowing = false;
  }

  async showServerError(id: string | number, message: any): Promise<void> {
    let language = localStorage.getItem('lang');

    if (!language) {
      language = 'en';
    }

    if (language === 'ca') {
      language = 'cat';
    }

    let displayMessage = '';
  let messageObj;

  try {
    // Convert message to object if it's a string
    if (typeof message === 'string') {
      try {
        messageObj = JSON.parse(message);
      } catch (e) {
        messageObj = { en: message }; // Fallback if parsing fails
      }
    } else {
      messageObj = message;
    }

    // Simple language selection logic
    if (messageObj[language]) {
      displayMessage = messageObj[language];
    } else if (messageObj.en) {
      displayMessage = messageObj.en;
    } else if (Object.keys(messageObj).length > 0) {
      displayMessage = messageObj[Object.keys(messageObj)[0]];
    } else {
      displayMessage = String(message);
    }
  } catch (error) {
    displayMessage = String(message);
  }

  if (id === 0) {
    displayMessage = this.translateService.instant('COMMON.ALERT.SERVER_ERROR');
  }

  // Prevent multiple modals
  if (this.isErrorShowing) {
    return;
  }
  this.isErrorShowing = true;

    const modal = await this.modalController.create({
      component: HTTPResponseModalComponent,
      componentProps: {
        status: id,
        message: displayMessage
      },
      cssClass: 'http-response-modal'
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    this.isErrorShowing = false;
  }

  async showServerInfo(id: string | number, message: string): Promise<void> {
    // Prevent multiple modals
    if (this.isInfoShowing) {
      return;
    }
    this.isInfoShowing = true;

    const modal = await this.modalController.create({
      component: HTTPResponseModalComponent,
      componentProps: {
        status: id,
        message: message
      },
      cssClass: 'http-response-modal'
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    this.isInfoShowing = false;
  }

  translateServerResponse(message: any): String {
    let language = localStorage.getItem('lang');

    if (!language) {
      language = 'es';
    }

    if (language === 'ca') {
      language = 'cat';
    }
    let displayMessage = '';
    let messageObj;

    try {

      // Convert message to object if it's a string
      if (typeof message === 'string') {
        try {
          messageObj = JSON.parse(message);
        } catch (e) {
          messageObj = { en: message }; // Fallback if parsing fails
        }
      } else {
        messageObj = message;
      }

      // Simple language selection logic
      if (messageObj[language]) {
        displayMessage = messageObj[language];
      } else if (messageObj.en) {
        displayMessage = messageObj.en;
      } else if (Object.keys(messageObj).length > 0) {
        displayMessage = messageObj[Object.keys(messageObj)[0]];
      } else {
        displayMessage = String(message);
      }
    } catch (error) {
      displayMessage = String(message);
    }

    return displayMessage;
  }
}
